// extracted by mini-css-extract-plugin
export default {"racesContainer":"Races_racesContainer__iho6L"};